import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Eye, Layers, Shield, Target } from 'lucide-react';
export function RulesSection() {
  return <section className="w-full px-4 md:px-6" data-id="element-660">
      <div className="max-w-3xl mx-auto" data-id="element-661">
        <FadeIn className="mb-16 text-center" data-id="element-662">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-663">
            La solución real:{' '}
            <span className="text-brand-gold" data-id="element-664">Reglas del Dinero</span>
          </h2>
          <p className="text-lg text-brand-muted" data-id="element-665">
            Este manual te enseña un sistema simple y ejecutable para construir
            control.
          </p>
        </FadeIn>

        <div className="space-y-12" data-id="element-666">
          {/* Rule 1 */}
          <FadeIn className="relative pl-8 md:pl-12 border-l border-brand-gold/30" data-id="element-667">
            <div className="absolute -left-3 top-0 bg-brand-bg border border-brand-gold text-brand-gold w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" data-id="element-668">
              1
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-669">
              Claridad absoluta
            </h3>
            <div className="flex flex-col md:flex-row gap-6" data-id="element-670">
              <div className="flex-1" data-id="element-671">
                <p className="text-brand-text mb-4" data-id="element-672">Saber exactamente:</p>
                <ul className="space-y-2 mb-4" data-id="element-673">
                  <li className="flex items-center gap-2 text-brand-muted" data-id="element-674">
                    <Eye className="w-4 h-4 text-brand-gold" data-id="element-675" /> Cuánto tienes
                  </li>
                  <li className="flex items-center gap-2 text-brand-muted" data-id="element-676">
                    <Eye className="w-4 h-4 text-brand-gold" data-id="element-677" /> Dónde está
                  </li>
                  <li className="flex items-center gap-2 text-brand-muted" data-id="element-678">
                    <Eye className="w-4 h-4 text-brand-gold" data-id="element-679" /> Para qué sirve
                  </li>
                </ul>
                <p className="text-brand-text italic" data-id="element-680">
                  Sin claridad, tu cerebro inventa historias. Y las historias
                  cuestan dinero.
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Rule 2 */}
          <FadeIn className="relative pl-8 md:pl-12 border-l border-brand-gold/30" data-id="element-681">
            <div className="absolute -left-3 top-0 bg-brand-bg border border-brand-gold text-brand-gold w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" data-id="element-682">
              2
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-683">
              Separación estratégica
            </h3>
            <p className="text-brand-text mb-6" data-id="element-684">
              Tu dinero se divide por función, no por emoción.
            </p>

            <div className="bg-brand-card p-6 rounded-lg border border-brand-bg" data-id="element-685">
              <h4 className="text-sm uppercase tracking-wider text-brand-muted font-bold mb-4" data-id="element-686">
                Las 4 funciones del dinero:
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-687">
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-688">
                  <span className="text-brand-gold font-bold" data-id="element-689">1</span>
                  <span className="text-white" data-id="element-690">Supervivencia</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-691">
                  <span className="text-brand-gold font-bold" data-id="element-692">2</span>
                  <span className="text-white" data-id="element-693">Estabilidad</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-694">
                  <span className="text-brand-gold font-bold" data-id="element-695">3</span>
                  <span className="text-white" data-id="element-696">Crecimiento</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-697">
                  <span className="text-brand-gold font-bold" data-id="element-698">4</span>
                  <span className="text-white" data-id="element-699">Multiplicación</span>
                </div>
              </div>
              <p className="mt-4 text-center text-brand-gold font-serif italic" data-id="element-700">
                "Sin estabilidad, la multiplicación es fantasía."
              </p>
            </div>
          </FadeIn>

          {/* Rule 3 */}
          <FadeIn className="relative pl-8 md:pl-12 border-l border-brand-gold/30" data-id="element-701">
            <div className="absolute -left-3 top-0 bg-brand-bg border border-brand-gold text-brand-gold w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" data-id="element-702">
              3
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-703">
              Rol definido antes de moverlo
            </h3>
            <p className="text-brand-text mb-4" data-id="element-704">
              Antes de gastar o invertir, decides:
            </p>
            <ul className="space-y-2 mb-4 bg-brand-card/30 p-4 rounded border-l-2 border-brand-gold" data-id="element-705">
              <li className="text-brand-text" data-id="element-706">
                ¿Este dinero puede asumir riesgo?
              </li>
              <li className="text-brand-text" data-id="element-707">¿Qué pasa si sale mal?</li>
              <li className="text-brand-text" data-id="element-708">¿Cuál es el límite?</li>
            </ul>
            <p className="text-brand-text" data-id="element-709">
              Esto corta el impulso. Y el impulso, en finanzas, es caro.
            </p>
          </FadeIn>

          {/* Implementation - 4 Accounts */}
          <FadeIn className="mt-20 pt-12 border-t border-brand-card" data-id="element-710">
            <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-711">
              “Ok… pero ¿cómo lo ejecuto en la vida real?”
            </h3>
            <p className="text-center text-brand-muted mb-10" data-id="element-712">
              Con murallas. El manual te da el mapa práctico de{' '}
              <strong className="text-white" data-id="element-713">4 cuentas esenciales</strong>:
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-714">
              {[{
              name: 'Personal',
              icon: <Target className="w-6 h-6" data-id="element-715" />
            }, {
              name: 'Operativa',
              sub: '(Negocio)',
              icon: <Layers className="w-6 h-6" data-id="element-716" />
            }, {
              name: 'Protección',
              icon: <Shield className="w-6 h-6" data-id="element-717" />
            }, {
              name: 'Inversión',
              icon: <Activity className="w-6 h-6" data-id="element-718" />
            }].map((acc, i) => <div key={i} className="flex flex-col items-center justify-center p-6 bg-brand-card rounded-lg border border-brand-gold/10 hover:border-brand-gold/50 transition-colors text-center h-32" data-id="element-719">
                  <div className="text-brand-gold mb-3" data-id="element-720">{acc.icon}</div>
                  <span className="font-bold text-white" data-id="element-721">{acc.name}</span>
                  {acc.sub && <span className="text-xs text-brand-muted mt-1" data-id="element-722">
                      {acc.sub}
                    </span>}
                </div>)}
            </div>
            <p className="text-center text-brand-muted mt-8 text-sm" data-id="element-723">
              No para complicarte. Para que un golpe no te destruya todo.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}
// Helper icon component since Activity wasn't imported above but used
function Activity(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-724">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" data-id="element-725" />
    </svg>;
}